'use client';

import type { FC } from 'react';
import React from 'react';

import useGuard from '@/hooks/useGuard';
import { NoPermission } from './NoPermission';

interface Props {
    children: React.ReactNode;
    routeKey: string;
}

const Guard: FC<Props> = ({ children, routeKey }) => {
    const hasPermission = useGuard({ routeKey });

    if (!hasPermission) {
        return <NoPermission />;
    }

    return <>{children}</>;
};

export default Guard;
